import React from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow,
} from 'devextreme-react/data-grid';
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarCalendarioIssDs } from "../DataSources";
import UserInfo from "../UserInfo";

export default class CalendarioIssBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                    <PaginaToolbar titulo="Cadastro de Calendario ISS">
                        <DataGrid
                            dataSource={criarCalendarioIssDs()}
                            showBorders={true}
                            rowAlternationEnabled={true} remoteOperations={true} 
                            focusedRowEnabled={true}
                            onInitNewRow={this.initNewRow}>
                            <HeaderFilter visible={true} />
                            <FilterRow visible={true} />
                            <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                            <Column dataField={'id'} />
                            <Column dataField={'ano'} />
                            <Column dataField={'mes'} />
                            <Column dataField={'dataLimiteEscrituracao'} />
                            <Column dataField={'dataLimiteCancelamento'} />
                            <Paging defaultPageSize={20} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={[10, 20, 30]}
                            />
                        </DataGrid>
                    </PaginaToolbar>
                </div>
        );
    }

    initNewRow(e){
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }
}
